<template>
  <v-container>
    <v-row>
      <v-col cols="3" md="3" sm="12">
        <v-text-field v-model="dateStart" label="Date Start" type="date" hide-details clearable />
      </v-col>
      <v-col cols="3" md="3" sm="12">
        <v-text-field v-model="dateEnd" label="Date End" type="date" hide-details clearable />
      </v-col>
      <v-spacer />
      <v-col cols="3" md="3" sm="12">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details clearable
                      :loading="lostInvLoading" />
      </v-col>
    </v-row>
    <div style="overflow: auto;">
      <v-responsive min-width="1200">
        <v-data-table :headers="headers" :items-per-page.sync="itemsPerPage" :page.sync="page" :items="lostInvList"
                      :server-items-length="lostInvCount" :footer-props="{
                        'items-per-page-options': [5, 10, 15, 20],
                      }" :loading="lostInvLoading || lostInvCounting" class="elevation-0">
          <template v-slot:item="row">
            <tr>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-if="authPermissions.has('list:edit')" class="mx-2" fab dark small v-bind="attrs" color="yellow"
                           v-on="on" @click="editLostInventory(row.item)">
                      <v-icon dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Transaction</span>
                </v-tooltip>
              </td>
              <td>{{ row.item.supplier_id }}-{{ row.item.stock_code }}</td>
              <td>{{ row.item.product_name }}</td>
              <td>{{ row.item.brand_name }}</td>
              <td>₱ {{ formatMoney(row.item.cost) }}</td>
              <td>{{ row.item.quantity }} {{ row.item.unit }}</td>
              <td>₱ {{ formatMoney(row.item.totalAmount) }}</td>
              <td class="truncate">
                {{ dateFormat(row.item.date_lost) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-responsive>
    </div>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { moneyMixin } from './../../mixins/helper.mixins'
import searchDelay from '@/extra-functions/searchDelay.extra'
import lostInvRepository from '@/repositories/lost-inventory.repository'
import { errorHandler } from '../../../../extra-functions/store.extra'
import { apiVars } from '@/extra-functions/api-helper.extra'

const delayedSearch = searchDelay()

function tableVars() {
  return {
    searching: false,
    headers: [
      { text: 'Config' },
      { text: 'Supplier-Stock ID', sortable: false },
      { text: 'Product Name', value: 'productName' },
      { text: 'Brand', value: 'brandName' },
      { text: 'Cost', value: 'cost' },
      { text: 'Quantity', value: 'quantity' },
      { text: 'Total Amount', value: 'totalAmount' },
      { text: 'Date' },
    ],
    itemsPerPage: 5,
    page: 1,
    search: null,
    dateStart: null,
    dateEnd: null,
  }
}
export default {
  name: 'VIndexLostInventories',
  data() {
    return {
      ...tableVars(),
      ...apiVars('lostInv', {
        count: 0,
        counting: false,
        countErrors: [],
      }),
    }
  },
  created() {
    this.getData()
  },
  computed: {
    ...mapState({
      lostInventoryUpdated: state => state.lostInventory.channelUpdate,
      storeId: state => state.settings.storeId,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  watch: {
    itemsPerPage(val) {
      this.lostInvLoading = true
      delayedSearch(() => { this.getLostInv() })
    },
    page(val) {
      this.lostInvLoading = true
      delayedSearch(() => { this.getLostInv() })
    },
    search() {
      this.getData()
    },
    dateStart() {
      this.getData()
    },
    dateEnd() {
      this.getData()
    },
    lostInventoryUpdated() {
      this.getData()
    },
  },
  methods: {
    ...mapActions({
      fetch: 'lostInventory/fetch',
      fetchDataCount: 'lostInventory/fetchDataCount',
    }),
    editStock(stockData) {
      this.$emit('editStock', stockData)
    },
    editLostInventory(item) {
      this.$emit('edit', item)
    },
    dateFormat(ndate) {
      const date = new Date(ndate)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')

      return `${month}/${day}/${year}`
    },
    getLostInv() {
      const params = {
        index: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        ...this.filters(),
      }
      lostInvRepository.storeIndex(this.storeId, params)
        .then(({ data }) => {
          this.lostInvList = data.map(e => {
            return {
              ...e,
              totalAmount: e.quantity * e.cost,
            }
          })
        })
        .catch(e => { this.lostInvErrors = errorHandler(e) })
        .then(() => { this.lostInvLoading = false })
    },
    getLostInvCount() {
      lostInvRepository.storeCount(this.storeId, { ...this.filters() })
        .then(({ data }) => {
          this.lostInvCount = data
        })
        .catch(e => { this.lostInvCountErrors = errorHandler(e) })
        .then(() => { this.lostInvCounting = false })
    },
    getData() {
      this.lostInvLoading = true
      this.lostInvCounting = true
      delayedSearch(() => {
        this.getLostInv()
        this.getLostInvCount()
      })
    },
    filters() {
      return {
        search: this.search,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
      }
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
